<template>
<div class=corporations>
  <corporationsList></corporationsList>
</div>
</template>

<script>
import corporationsList from './corporationsList.vue'

export default {
  components: {
    corporationsList
  }
}
</script>
<style scoped>
.corporations {
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/masterPanel/masterView/CorporationView/corporations.vue